<script setup>
import { onMounted, ref, watchEffect, reactive, computed, onUnmounted } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import {
  consumption,
  ssoUpdatePassword,
  ssoInfo,
  systemConfig,
  ssoUpdatePhone,
  agentDomain,
  batchDownloadPage
} from "../api/index";
import { companyGetMemberEquityQuota } from '../api/member'
import { smsGetCode } from "../api/authentication";
import { bannerList } from "../api/notice";
import { formatDate } from "../assets/js/date";
import { removeCookie } from "../assets/js/cookie";
import Bus from "../js/Bus";
import { useStore } from "vuex";
import noticebar from "../components/NoticeBar.vue";
import PayLoadding from "../components/PayLoadding.vue"
import Question from "../components/Question.vue"
const store = useStore();
const router = useRouter();
const route = useRoute();
const menuVisible = ref(false);
const visible = ref(false);
const username = ref("");
const infoMsg = ref("");
const isHome = ref(false);
const menuList = ref(["工作台", "成员管理", "消费记录", "统计分析"]);
const activeIndex = ref("/home");
const upPassVisible = ref(false);
const upPhoneVisible = ref(false);
const formLabelWidth = "80px";
const upPassFormRef = ref(null);
const upPhoneFormRef = ref(null);
const showText = ref(true);
const second = ref(60);
const btnLoading = ref(false);
const upPassForm = reactive({
  oldPassword: "",
  newPassword: ""
});
const upPhoneForm = reactive({
  password: "",
  telephone: "",
  authCode: ""
});
const validatorPwd = (rule, value, callback) => {
  // 检验密码强度
  if (!value.trim().length) {
    return callback(new Error("请输入密码！"));
  }
  if (/\d/.test(value) && /[a-zA-Z]/.test(value)) return callback();
  callback(new Error("设置6位及以上字母+数字组合的密码"));
};
const validatorPhone = (rule, value, callback) => {
  if (userInfo.value.phone && userInfo.value.phone === value.trim()) {
    return callback(new Error("新手机号不能与原手机号重复"));
  }
  callback();
};
const formRules = {
  oldPassword: [{ required: true, message: "密码不能为空", trigger: "blur" }],
  newPassword: [
    { required: true, message: "密码不能为空", trigger: "blur" },
    { min: 6, message: "设置6位及以上字母+数字组合的密码", trigger: "blur" },
    { validator: validatorPwd, triger: "blur" }
  ],
  password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
  telephone: [
    { required: true, message: "手机号不能为空", trigger: "blur" },
    { validator: validatorPhone, triger: "blur" }
  ],
  authCode: [{ required: true, message: "验证码不能为空", trigger: "blur" }]
};

const singleCharge = computed({
  get() {
    return store.state.singleCharge;
  },
  set(val) {
    store.commit("updateSingleCharge", val);
  }
});

const amount = computed({
  get() {
    return store.state.amount;
  },
  set(val) {
    store.commit("updateAmount", val);
  }
});

const userInfo = computed({
  get() {
    return store.state.userInfo;
  },
  set(val) {
    store.commit("updateUserInfo", val);
  }
});

const packageList = computed({
  get() {
    return store.state.packageList;
  },
  set(val) {
    store.commit("updatePackageList", val);
  }
});

const select = (index, indexPath) => {
  updateActiveMenuIndex(index);
};
const updateActiveMenuIndex = index => {
  activeIndex.value = index;
};
const handleOpen = (key, keyPath) => {
};
const handleClose = (key, keyPath) => {
};

const handleVisible = visible => {
  menuVisible.value = visible;
};

const logout = () => {
  ElMessageBox.confirm("确定退出登录吗？", "系统提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    confirmButtonClass: 'btn-item btn-active',
    cancelButtonClass: 'btn-item',
  })
    .then(() => {
      removeCookie();
      store.commit("updateUserInfo", {});
      router.replace({ path: "/login" });
    })
    .catch(() => {});
};

const getSystemConfig = () => {
  systemConfig("SINGLE_CHARGE").then(res => {
    if (res && res.data) {
      store.commit("updateSingleCharge", res.data);
    }
  });
};

const getUserInfo1 = () => {
  ssoInfo().then(res => {
    if (res) {
      store.commit("updateUserInfo", res.data);
      store.commit("updateAmount", res.data.balance);
      store.commit("updatePackageList", res.data.packageList);
    }
  });
};

const memberEquityList = ref([])

const getMemberEquityQuota = (memberId) => {
  companyGetMemberEquityQuota({
    memberId: memberId
  }).then(res => {
    memberEquityList.value = res.data.filter(item => item.isRestriction === true)
  })
}

const isGetUser = ref(false)

const getUserInfo = isCreate => {
  ssoInfo().then(res => {
    if (res) {
      getPackageEquities()
      getMemberEquityQuota(res.data.id)
      localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE + '_' + 'userInfo', JSON.stringify(res.data))
      store.commit("updateUserInfo", res.data);
      store.commit("updateAmount", res.data.balance);
      store.commit("updatePackageList", res.data.packageList);
      isGetUser.value = true
      // 企业认证状态:0->未通过；1->企业认证通过;2->代理人商认证通过；3->企业认证审核中；4->代理人商认证审核中 5个人状态通过
      if (res.data.authStatus === 0) {
        store.commit("authType", 0);
        store.commit("updateAuth", true);
      } else if (res.data.authStatus === 3) {
        store.commit("authType", 1);
        store.commit("updateAuth", true);
      } else {
        if (isCreate) {
          if (res.data.isAgent) {
            let num = 100;
            if (
              res.data.balance * 1 <
                (singleCharge.value *
                  num *
                  (res.data.agentLevel.discount * num)) /
                  (num * num) &&
              !res.data.packageList.length
            ) {
              ElMessage.error("余额不足，请充值");
              return;
            }
          } else {
            if (
              res.data.balance * 1 < singleCharge.value * 1 &&
              !res.data.packageList.length
            ) {
              ElMessage.error("余额不足，请充值");
              return;
            }
          }
          localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE + '_' + "stepIndex");
          localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE + '_' + "writeId");
          localStorage.removeItem(process.env.VUE_APP_LOCAL_STORAGE + '_' + "allFeatures");
          if (route.path === "/new") {
            router.replace({ path: "/new" });
            Bus.$emit("pageChange", 1);
          } else {
            router.push({ path: "/new" });
          }
        }
      }
    }
  });
};

// const createNew = () => {
//   getUserInfo(true);
// };

const changePassword = () => {
  if (upPassFormRef.value) {
    upPassFormRef.value.resetFields();
  }
  upPassForm.oldPassword = "";
  upPassForm.newPassword = "";
  upPassVisible.value = true;
};

const doChangePassword = () => {
  upPassFormRef.value.validate(valid => {
    let msg = "请填写密码！";
    // 不通过校验
    if (!valid) return ElMessage.error(msg);
    // 通过校验
    btnLoading.value = true;
    let params = {
      oldPassword: upPassForm.oldPassword,
      newPassword: upPassForm.newPassword
    };
    ssoUpdatePassword(params)
      .then(res => {
        btnLoading.value = false;
        upPassVisible.value = false;
        removeCookie();
        store.commit("updateUserInfo", {});
        router.replace({ path: "/login" });
      })
      .catch(e => {
        btnLoading.value = false;
      });
  });
};

const changePhone = () => {
  if (upPhoneFormRef.value) {
    upPhoneFormRef.value.resetFields();
  }
  upPhoneForm.password = "";
  upPhoneForm.telephone = "";
  upPhoneForm.authCode = "";
  upPhoneVisible.value = true;
};

const getCode = () => {
  let phone = upPhoneForm.telephone;
  if (!phone.trim()) {
    ElMessage.error("请输入手机号");
    upPhoneFormRef.value.validateField("telephone");
    return;
  }
  smsGetCode({ phone }).then(res => {
    showText.value = false;
    let interval = setInterval(() => {
      let times = --second.value;
      second.value = times < 10 ? "0" + times : times;
    }, 1000);
    setTimeout(() => {
      clearInterval(interval);
      second.value = 60;
      showText.value = true;
    }, 60000);
  });
};

const doChangePhone = () => {
  upPhoneFormRef.value.validate(valid => {
    // 不通过校验
    if (!valid) return;
    // 通过校验
    btnLoading.value = true;
    let params = {
      password: upPhoneForm.password,
      telephone: upPhoneForm.telephone,
      authCode: upPhoneForm.authCode
    };
    ssoUpdatePhone(params)
      .then(res => {
        btnLoading.value = false;
        upPhoneVisible.value = false;
        ElMessage.success(res.message);
        getUserInfo1();
      })
      .catch(e => {
        btnLoading.value = false;
      });
  });
};

const charge = () => {
  store.commit("authType", 2);
  store.commit("updateEquitiesName1", '')
  store.commit("updateChargeType", 0);
  store.commit("updateAuth", true);
};

const getData = () => {
  consumption().then(res => {
    infoMsg.value = res.data;
  });
};

const openWindow = path => {
  let baseUrl = window.location.origin;
  let pathArr = window.location.pathname.split("/");
  pathArr.splice(pathArr.length - 1, 1, path);
  let url = baseUrl + pathArr.join("/");
  window.open(url, "_blank");
};

const toAuth = authStatus => {
  if (authStatus === 5) {
    openWindow("#/auth?type=1");
  } else if (authStatus === 3 || authStatus === 7) {
    store.commit("authType", 1);
    store.commit("updateAuth", true);
  } else {
    openWindow("#/auth?type=0");
  }
};

const balanceDetail = () => {
  router.push({
    path: "/balance"
  });
};

const packageDetail = item => {
  if (route.path === "/package") {
    router.push({
      path: "/package",
      query: {
        id: item.id
      }
    });
    Bus.$emit("packageChange", item.id);
  } else {
    router.push({
      path: "/package",
      query: {
        id: item.id
      }
    });
  }
};

const packageListDetail = () => {
  router.push({
    path: "/package-list"
  });
};

const infoDetail = reactive({
  data: {}
});

const infoClick = () => {
  localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE + '_' + "noticeDetail", JSON.stringify(infoDetail.data));
  if (route.path === "/noticeDetail") {
    router.push({ path: "/noticeDetail" });
    Bus.$emit("noticeDetailChange", "1");
  } else {
    router.push({ path: "/noticeDetail" });
  }
};

const moreClick = () => {
  if (route.path === "/notice") {
    router.push({ path: "/notice" });
    Bus.$emit("noticeChange", "1");
  } else {
    router.push({ path: "/notice" });
  }
};

const options = reactive({
  text: "", // 通知内容
  size: "12px", // 通知内容文字大小（默认16px）
  color: "#666666", // 通知内容文字颜色(默认#f60)
  backround: "#fff", //背景颜色(默认#fff7cc)
  delay: "1000", // 动画延迟时间(默认一秒后开始滚动，单位毫秒)
  speed: "50" // 滚动速率默认50 (px/s)
});

const getNotice = () => {
  bannerList({
    number: 1,
    platform: 1
  }).then(res => {
    if (res.data && res.data.length) {
      options.text = res.data[0].title;
      infoDetail.data = res.data[0];
    }
  });
};

const domainInfo = computed({
  get() {
    return store.state.domainInfo;
  },
  set(val) {
    store.commit("updateDomainInfo", val);
  }
});

const getDomain = () => {
  agentDomain().then(res => {
    const currentDate = new Date();
    let year = currentDate.getFullYear();  // 返回当前年份
    if (res.data) {
      domainInfo.value = {
        copyrightInfo: res.data.copyrightInfoStart !== '' && res.data.copyrightInfoEnd !== '' ? res.data.copyrightInfo : '',
        copyrightInfoStart: res.data.copyrightInfoStart,
        copyrightInfoEnd: res.data.copyrightInfoEnd,
        domain: res.data.domain,
        icpNumber: res.data.icpNumber,
        publicSecurityNumber: res.data.publicSecurityNumber,
        systemName: res.data.systemName || '软著登记服务平台',
        icon: res.data.icon,
        subordinateAccountPaySetting: res.data.subordinateAccountPaySetting,
        status: res.data.status
      }
    } else {
      domainInfo.value = {
        copyrightInfo: 'Copyright@2016-' + year + '&nbsp;&nbsp;安徽高山科技有限公司&nbsp;&nbsp;版权所有',
        icpNumber: '皖ICP备17001294号',
        publicSecurityNumber: '皖公网安备 34019202000669号',
        systemName: '软著登记服务平台',
      }
    }
    store.commit('updateDomainInfo', domainInfo.value)
    document.title = domainInfo.value.systemName
  })
}

const equitiesList = ref([])

 const getPackageEquities = () => {
    systemConfig("PACKAGE_EQUITIES").then(res => {
      if (res && res.data) {
        equitiesList.value = JSON.parse(res.data)
        // if (userInfo.value && userInfo.value.companyId * 1 !== 43) {
        //   equitiesList.value = equitiesList.value.filter(e => e.equities !== 'MANUAL_WRITE')
        // }
      }
    });
  };

  const muitEquities = (list) => {
    let arr = []
    list.forEach(e => {
      let equities = JSON.parse(e.equities)
      if (equities.length > 1) {
        arr.push(
          {
             name: e.packageName,
             equities: equities
          }
        )
      }
    });
    return arr
  }

const showPayloadding = ref(false)

const feedback = () => {
  store.commit('updateFeedback', true)
}

/**
 * 检测localStorage是否已满，若满则清除键中包含中文的数据
 * @returns {Object} 操作结果对象
 *          {boolean} isFull - localStorage是否已满
 *          {number} clearedCount - 清除的项目数量
 *          {boolean} success - 操作是否成功
 */
 const checkAndClearLocalStorage = () => {
  let isFull = false;
  let clearedCount = 0;
  let success = true;

  const testKey = '__storage_test__1';
  try {
    // 测试存储容量
    localStorage.setItem(testKey, '1');
    localStorage.removeItem(testKey);
  } catch (e) {
    if (e instanceof DOMException && (
      e.code === 22 || 
      e.code === 1014 || 
      e.name === 'QuotaExceededError' || 
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    )) {
      isFull = true;
      
      // 清除包含中文的键
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && /[\u4e00-\u9fa5]/.test(key)) {
          localStorage.removeItem(key);
          clearedCount++;
        }
      }
      
      // 再次测试
      try {
        localStorage.setItem(testKey, '1');
        localStorage.removeItem(testKey);
      } catch (e) {
        success = false;
        console.error('清除后localStorage仍然空间不足');
      }
    } else {
      success = false;
      console.error('检测localStorage时发生未知错误:', e);
    }
  }

  return {
    isFull,
    clearedCount,
    success
  };
}

const checkStorage = () => {
  // 使用示例
  const result = checkAndClearLocalStorage();
  if (result.isFull) {
    if (result.success) {
      console.error(`已成功清除 ${result.clearedCount} 个包含中文的项目`);
    } else {
      console.error('清除后空间仍然不足，请考虑其他存储方式');
    }
  } else {
    console.error('localStorage空间充足');
  }
}

const showExportList = ref(false)

const batchDownloadTotal = ref(0)
const tableData = ref([])
const batchDownloadForm = reactive({
    pageNum: 1,
    pageSize: 10,
  });
const getBatchDownloadPage = () => {
  batchDownloadPage(batchDownloadForm).then(res => {
    if (res) {
      tableData.value = res.data.list
      batchDownloadTotal.value = res.data.total
      showExportList.value = true
    }
  })
}

const handleCurrentChange = (currentPage) => {
  batchDownloadForm.pageNum = currentPage
  getBatchDownloadPage()
}

const showExportTable = () => {
  batchDownloadForm.pageNum = 1
  getBatchDownloadPage()
}

const handleClick = (row) => {
  window.open(row.fileUrl)
}

const isTargetDomain = () => {
  return window.location.hostname === 'rz.lingxing.cc'
}

const toEquitiesRecord = (item) => {
  if (route.path === "/packageRecord") {
    router.push({
      path: "/packageRecord",
      query: {
        name: item.name
      }
    });
    Bus.$emit("packageRecordChange", item.name);
  } else {
    router.push({
      path: "/packageRecord",
      query: {
        name: item.name
      }
    });
  }
}

const isEmptyEquities = (item) => {
  if (userInfo.value && userInfo.value.companyId * 1 === 176) {
    if ((item.equities !== 'AUTOMATION' ||
          (item.equities === 'AUTOMATION' &&
            userInfo.value.packageMap[item.equities].length && 
            userInfo.value.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) !== 0)) && item.name !== '华代代理通道') {
      return false
    } else {
      return true
    }
  } else {
    if((item.equities !== 'AUTOMATION' ||
        (item.equities === 'AUTOMATION' &&
          userInfo.value.packageMap[item.equities].length && 
          userInfo.value.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) !== 0))) {
      return false
    } else {
      return true
    }
  }
}

onMounted(() => {
  checkStorage()
  showPayloadding.value = false
  getDomain();
  getUserInfo();
  // getBatchDownloadPage()
  getSystemConfig();
  Bus.$off("payLoad");
  Bus.$on("payLoad", e => {
    showPayloadding.value = e
  });
});

onUnmounted(() => {
  Bus.$off("payLoad");
});

watchEffect(() => {
  getNotice();
  updateActiveMenuIndex(route.path);
});
</script>

<template>
  <div class="layout">
    <el-container>
      <el-header class="header all-header">
        <div class="header-nav flex-between">
          <div class="home-title">{{domainInfo.systemName || '软著登记服务平台'}}</div>
          <div class="title flex-start">
            <!-- <span class="balance">余额</span>
            <span class="balance-value">{{ amount.toFixed(2) }}</span> -->
            <!-- <span @click="balanceDetail" v-if="userInfo.isAdmin || !userInfo.companyId" class="balance2">明细></span> -->
            <span class="balance">套餐剩余</span>
            <!-- <div class="balance-all" v-if="userInfo && userInfo.packageMap">
              <div class="balance-item" v-for="(item, index) in userInfo.isAutomationCompany * 1 === 1 ? equitiesList :
                equitiesList.filter(e => e.equities !== 'AUTOMATION') " :key="index">
                <template v-if="userInfo && userInfo.companyId * 1 === 176">
                  <el-tooltip
                    v-if="(item.equities !== 'AUTOMATION' ||
                    (item.equities === 'AUTOMATION' &&
                      userInfo.packageMap[item.equities].length && 
                      userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) !== 0)) && item.name !== '华代代理通道'"
                    effect="dark"
                    :disabled="!muitEquities(userInfo.packageMap[item.equities]).length"
                    placement="bottom">
                    <template #content>
                      <div style="width:200px">
                        <div v-for="(it, i) in muitEquities(userInfo.packageMap[item.equities])" :key="i">
                          <span>{{'[' + it.name + ']中含'}}</span>
                          <span v-for="(c, ci) in it.equities" :key="ci">
                            {{'[' + c.name + ']'}}<span v-if="ci !== it.equities.length - 1">、</span>
                          </span>
                          <span>权益</span>
                        </div>
                      </div>
                    </template>
                    <div @click="toEquitiesRecord(item)" style="cursor: pointer;">
                      <div v-if="userInfo.packageMap[item.equities].length" class="balance-num">
                        {{ userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) }}
                        <span v-if="muitEquities(userInfo.packageMap[item.equities]).length" style="display:flex;align-items:center;justify-content: center;color:#ff8f1f;margin-left:2px">
                          <el-icon><Warning /></el-icon>
                        </span>
                      </div>
                      <div v-else class="balance-num">0</div>
                      <div class="balance-text">{{item.name}}</div>
                    </div>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tooltip
                    v-if="(item.equities !== 'AUTOMATION' ||
                    (item.equities === 'AUTOMATION' &&
                      userInfo.packageMap[item.equities].length && 
                      userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) !== 0))"
                    effect="dark"
                    :disabled="!muitEquities(userInfo.packageMap[item.equities]).length"
                    placement="bottom">
                    <template #content>
                      <div style="width:200px">
                        <div v-for="(it, i) in muitEquities(userInfo.packageMap[item.equities])" :key="i">
                          <span>{{'[' + it.name + ']中含'}}</span>
                          <span v-for="(c, ci) in it.equities" :key="ci">
                            {{'[' + c.name + ']'}}<span v-if="ci !== it.equities.length - 1">、</span>
                          </span>
                          <span>权益</span>
                        </div>
                      </div>
                    </template>
                    <div @click="toEquitiesRecord(item)" style="cursor: pointer;">
                      <div v-if="userInfo.packageMap[item.equities].length" class="balance-num">
                        {{ userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) }}
                        <span v-if="muitEquities(userInfo.packageMap[item.equities]).length" style="display:flex;align-items:center;justify-content: center;color:#ff8f1f;margin-left:2px">
                          <el-icon><Warning /></el-icon>
                        </span>
                      </div>
                      <div v-else class="balance-num">0</div>
                      <div class="balance-text">{{item.name}}</div>
                    </div>
                  </el-tooltip>
                </template>
              </div>
              <div style="margin-left: -16px;" class="balance-item" v-if="userInfo && userInfo.packageMap && userInfo.isAutomationCompany * 1 === 1 && userInfo.packageMap['AUTOMATION'].filter(a => a.packageUseType === 1).length > 0">
                <div>
                  <div v-if="userInfo.packageMap && userInfo.packageMap['AUTOMATION'].filter(a => a.packageUseType === 1).length" class="balance-num">
                    至{{ formatDate(userInfo.packageMap['AUTOMATION'].filter(a => a.packageUseType === 1)[0].dueDate, "YYYY年MM月DD日") }}
                  </div>
                  <div v-else class="balance-num">0</div>
                  <div class="balance-text">自动化提交有效期</div>
                </div>
     
              </div>
              <span v-if="(userInfo.isAdmin || !userInfo.companyId)" @click="packageListDetail" class="balance1">更多></span>
            </div> -->
            <div class="balance-all balance-child" v-if="userInfo && userInfo.packageMap">
              <div class="balance-item" :class="{ 'balance-item-empty': isEmptyEquities(item) }" v-for="(item, index) in userInfo.isAutomationCompany * 1 === 1 ? equitiesList :
                equitiesList.filter(e => e.equities !== 'AUTOMATION') " :key="index">
                <template v-if="userInfo && userInfo.companyId * 1 === 176">
                  <el-tooltip
                    v-if="(item.equities !== 'AUTOMATION' ||
                    (item.equities === 'AUTOMATION' &&
                      userInfo.packageMap[item.equities].length && 
                      userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) !== 0)) && item.name !== '华代代理通道'"
                    effect="dark"
                    :disabled="!muitEquities(userInfo.packageMap[item.equities]).length"
                    placement="bottom">
                    <template #content>
                      <div style="width:200px">
                        <div v-for="(it, i) in muitEquities(userInfo.packageMap[item.equities])" :key="i">
                          <span>{{'[' + it.name + ']中含'}}</span>
                          <span v-for="(c, ci) in it.equities" :key="ci">
                            {{'[' + c.name + ']'}}<span v-if="ci !== it.equities.length - 1">、</span>
                          </span>
                          <span>权益</span>
                        </div>
                      </div>
                    </template>
                    <div @click="toEquitiesRecord(item)" style="cursor: pointer;">
                      <div v-if="memberEquityList.findIndex(m => m.equities === item.equities) !== -1" class="balance-num">{{ memberEquityList.find(m => m.equities === item.equities).remainingQuota }}</div>
                      <div v-else-if="userInfo.packageMap[item.equities].length" class="balance-num">
                        {{ userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) }}
                        <span v-if="muitEquities(userInfo.packageMap[item.equities]).length" style="display:flex;align-items:center;justify-content: center;color:#ff8f1f;margin-left:2px">
                          <el-icon><Warning /></el-icon>
                        </span>
                      </div>
                      <div v-else class="balance-num">0</div>
                      <div class="balance-text">{{item.name}}</div>
                    </div>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-tooltip
                    v-if="(item.equities !== 'AUTOMATION' ||
                    (item.equities === 'AUTOMATION' &&
                      userInfo.packageMap[item.equities].length && 
                      userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) !== 0))"
                    effect="dark"
                    :disabled="!muitEquities(userInfo.packageMap[item.equities]).length"
                    placement="bottom">
                    <template #content>
                      <div style="width:200px">
                        <div v-for="(it, i) in muitEquities(userInfo.packageMap[item.equities])" :key="i">
                          <span>{{'[' + it.name + ']中含'}}</span>
                          <span v-for="(c, ci) in it.equities" :key="ci">
                            {{'[' + c.name + ']'}}<span v-if="ci !== it.equities.length - 1">、</span>
                          </span>
                          <span>权益</span>
                        </div>
                      </div>
                    </template>
                    <div @click="toEquitiesRecord(item)" style="cursor: pointer;">
                      <div v-if="memberEquityList.findIndex(m => m.equities === item.equities) !== -1" class="balance-num">{{ memberEquityList.find(m => m.equities === item.equities).remainingQuota }}</div>
                      <div v-else-if="userInfo.packageMap[item.equities].length" class="balance-num">
                        {{ userInfo.packageMap[item.equities].filter(p => p.packageUseType === 0).reduce((acc, cur) => acc + cur.balance, 0) }}
                        <span v-if="muitEquities(userInfo.packageMap[item.equities]).length" style="display:flex;align-items:center;justify-content: center;color:#ff8f1f;margin-left:2px">
                          <el-icon><Warning /></el-icon>
                        </span>
                      </div>
                      <div v-else class="balance-num">0</div>
                      <div class="balance-text">{{item.name}}</div>
                    </div>
                  </el-tooltip>
                </template>
              </div>
              <div style="margin-left: -8px;" class="balance-item" v-if="userInfo && userInfo.packageMap && userInfo.isAutomationCompany * 1 === 1 && userInfo.packageMap['AUTOMATION'].filter(a => a.packageUseType === 1).length > 0">
                <div>
                  <div v-if="userInfo.packageMap && userInfo.packageMap['AUTOMATION'].filter(a => a.packageUseType === 1).length" class="balance-num">
                    至{{ formatDate(userInfo.packageMap['AUTOMATION'].filter(a => a.packageUseType === 1)[0].dueDate, "YYYY年MM月DD日") }}
                  </div>
                  <div v-else class="balance-num">0</div>
                  <div class="balance-text">自动化提交有效期</div>
                </div>
     
              </div>
              <span v-if="(userInfo.isAdmin || !userInfo.companyId)" @click="packageListDetail" class="balance1">更多></span>
            </div>
            <!-- memberEquityList -->
            <!-- <span v-if="packageList.length" class="balance-value1">
              {{ packageList.reduce((acc, cur) => acc + cur.balance, 0) }}
            </span>
            <span v-else class="balance-value1">0</span> -->
            <!-- <span class="balance-value2" v-if="packageList.length">{{
              "(" + packageList[0].packageName + ")"
            }}</span> -->
            <div
              v-if="
                userInfo.paySetting * 1 === 1 &&
                  (userInfo.isAdmin || !userInfo.companyId) && !isTargetDomain()
              "
              class="charge"
              @click="charge"
            >
              购买套餐
            </div>
          </div>
          <div class="info">
            <!-- <noticebar :options="options" :moreClick="moreClick" :infoClick="infoClick"></noticebar> -->
            <!-- <div class="info-create" @click="createNew">生成软件</div> -->
            <div class="info-list" @click="showExportTable">
              <svg t="1752548167236" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2404" width="200" height="200"><path d="M919.724 715.073c-1.14-27.354-19.024-42.46-42.619-41.9-23.378 0.555-38.8 15.93-40.994 43.89-1.61 20.54-0.232 41.299-0.677 61.951-1.115 51.829-12.339 63.805-64.15 64.827-49.91 0.985-99.854 0.323-149.782 0.327-115.351 0.01-230.704 0.094-346.056-0.065-79.44-0.11-86.325-6.973-86.704-84.204-0.069-13.77 0.625-27.626-0.64-41.293-2.692-29.088-16.328-44.222-39.415-45.527-24.92-1.412-43.084 15.533-44.99 45.495-1.742 27.442-0.763 55.071-0.582 82.615 0.59 89.17 40.096 129.183 129.294 129.692 92.967 0.532 185.939 0.119 278.91 0.14 27.546 0.023 55.094 0.032 82.64 0.022 70.59-0.025 141.195 0.957 211.759-0.393 62.212-1.19 107.706-37.177 112.958-91.757 3.941-40.953 2.765-82.6 1.048-123.82z" p-id="2405" fill="#6196FF"></path><path d="M197.858 440.866c88.757 88.806 177.526 177.602 266.293 266.398 3.647 3.65 7.362 7.23 10.984 10.903 14.285 14.481 30.948 22.644 51.135 14.996 6.585-2.495 11.48-6.255 15.665-10.523 2.763-1.912 5.47-4.017 7.93-6.408 45.635-44.375 240.102-239.468 285.027-284.574 4.826-4.845 9.464-10.053 13.27-15.71 12.213-18.165 10.54-35.96-3.947-51.855-14.818-16.257-33.48-16.94-51.874-7.894-8.93 4.39-16.286 12.46-23.557 19.673-30.24 29.99-139.611 139.264-212.845 212.61 0.038-114.56 0.05-229.12 0.027-343.68-0.006-34.399 1.091-68.86-0.615-103.176-1.587-31.878-17.058-48.14-41.969-48.957-25.551-0.839-41.055 14.728-44.538 46.158-1.32 11.908-0.623 24.054-0.63 36.092-0.04 75.676-0.02 151.355-0.02 227.034-0.002 56.59 0 113.181 0 169.773l-11.785 5.215c-22.75-22.663-45.526-45.304-68.245-67.997-47.453-47.405-94.29-95.445-142.576-141.985-21.8-21.014-47.07-21.359-64.429-4.84-18.71 17.803-18.05 39 2.326 63.95 4.334 5.306 9.512 9.931 14.373 14.797z" p-id="2406" fill="#6196FF"></path></svg>
              批量下载列表
            </div>
            <div class="flex" v-if="userInfo.companyType * 1 === 0">
              <!-- // 企业认证状态:0->未通过；1->企业认证通过;2->代理人商认证通过；3->企业认证审核中；4->代理人商认证审核中 5个人状态通过 -->
              <!-- 6 个人认证审核中  7 个人认证成功但是企业认证中 -->
              <el-dropdown style="z-index:10002" @visible-change="handleVisible">
                <div class="el-dropdown-link flex-end">
                  <div class="account flex">
                    <span @click="toAuth(userInfo.authStatus)" v-if="userInfo.authStatus * 1 === 0 || userInfo.authStatus * 1 === 3" style="color: #666666;cursor: pointer;">
                      {{ userInfo.companyName + "(未认证)" }}
                    </span>
                    <span
                      @click="toAuth(userInfo.authStatus)"
                      v-else-if="userInfo.authStatus * 1 === 7"
                      style="color: #666666;cursor: pointer;"
                    >
                      {{ userInfo.companyName + "(企业认证审核中)" }}
                    </span>
                    <span v-else>{{ userInfo.companyName }}</span>
                    <span @click="toAuth(userInfo.authStatus)" class="up" v-if="userInfo.authStatus * 1 === 5"><img src="../assets/image/up.png" alt="" />升级为企业</span>
                  </div>
                  <el-icon v-if="menuVisible" :size="12" class="el-icon--right">
                    <arrow-up />
                  </el-icon>
                  <el-icon v-else :size="12" class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <div class="flex" style="padding: 5px 16px;justify-content: flex-start;">
                      <div style="height: 20px;
                        width: 20px;
                        margin-right: 8px;
                        border-radius: 50%;
                        background: #6196ff;
                        display: flex;
                        justify-content: center;
                        align-items: center;">
                        <img
                          style=" width: 20px;
                          height: 20px;
                          border-radius: 50%;"
                          v-if="userInfo && userInfo.icon"
                          :src="userInfo.icon"
                          alt=""
                        />
                        <el-icon v-else :size="14" color="#FFF"><UserFilled /></el-icon>
                      </div>
                      <div>{{ userInfo.username }}</div>
                      <span v-if="userInfo.isAdmin">（管理员）</span>
                    </div>
                  </el-dropdown-menu>
                  <el-dropdown-menu class="flex">
                    <el-dropdown-item @click="changePassword"
                      >修改密码</el-dropdown-item
                    >
                    <el-dropdown-item
                    style="border-left: 1px solid rgba(0, 0, 0, 0.125);"
                      v-if="!userInfo.phone"
                      @click="changePhone"
                      >{{
                        userInfo.phone ? "换绑手机" : "设置手机号"
                      }}</el-dropdown-item
                    >
                    <el-dropdown-item style="border-left: 1px solid rgba(0, 0, 0, 0.125);" @click="logout">安全退出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div v-else class="flex">
               <div class="info-icon">
                <img
                  v-if="userInfo && userInfo.icon"
                  :src="userInfo.icon"
                  alt=""
                />
                <el-icon v-else :size="14" color="#FFF"><UserFilled /></el-icon>
              </div>
              <el-dropdown style="z-index:10002" @visible-change="handleVisible">
                <div class="el-dropdown-link flex-end">
                  <div class="account">{{ userInfo.username }}</div>
                  <el-icon v-if="menuVisible" :size="12" class="el-icon--right">
                    <arrow-up />
                  </el-icon>
                  <el-icon v-else :size="12" class="el-icon--right">
                    <arrow-down />
                  </el-icon>
                </div>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item @click="changePassword"
                      >修改密码</el-dropdown-item
                    >
                    <el-dropdown-item
                    style="border-left: 1px solid rgba(0, 0, 0, 0.125);"
                      v-if="!userInfo.phone"
                      @click="changePhone"
                      >{{
                        userInfo.phone ? "换绑手机" : "设置手机号"
                      }}</el-dropdown-item
                    >
                    <el-dropdown-item style="border-left: 1px solid rgba(0, 0, 0, 0.125);" @click="logout">安全退出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="208px" class="left-menu">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-vertical-demo"
            :router="true"
            @open="handleOpen"
            background-color="transparent"
            text-color="#FFFFFF"
            active-text-color="#6196FF"
            @close="handleClose"
            @select="select"
          >
            <!-- <el-menu-item index="/data-center" v-if="userInfo && (userInfo.companyId * 1 === 43 || userInfo.companyId * 1 === 4)">
              <template #title>
                <div>数据中心</div>
              </template>
            </el-menu-item> -->
            <el-sub-menu index="/">
              <template #title>
                <div>软著登记服务</div>
              </template>
              <el-menu-item index="/home">
                <template #title>
                  <div>登记列表</div>
                </template>
              </el-menu-item>
              <el-menu-item index="/correction-list">
                <template #title>
                  <div>补正记录</div>
                </template>
              </el-menu-item>
               <el-menu-item index="/todo">
                <template #title>
                  <div>待办事项</div>
                </template>
              </el-menu-item>
            </el-sub-menu>
            <!-- <el-menu-item index="/results">
              <template #title>
                <div>即将出结果</div>
              </template>
            </el-menu-item> -->
            <!-- <el-menu-item index="/correction-list" v-if="userInfo && (userInfo.companyId * 1 === 13 || userInfo.companyId * 1 === 43)">
              <template #title>
                <div>补正记录</div>
              </template>
            </el-menu-item> -->
            <!-- <el-menu-item index="/correction-list">
              <template #title>
                <div>补正记录</div>
              </template>
            </el-menu-item> -->
            <el-menu-item index="/applicant">
              <template #title>
                <div>著作权人库</div>
              </template>
            </el-menu-item>
            <!-- <el-menu-item index="/todo">
              <template #title>
                <div>待办事项</div>
              </template>
            </el-menu-item> -->
             <el-menu-item index="/aftersale">
              <template #title>
                <div>售后管理</div>
              </template>
            </el-menu-item>
            <el-sub-menu index="/setting">
              <template #title>
                <div>企业管理</div>
              </template>
              <el-menu-item index="/setting">
                <template #title>
                  <div>企业设置</div>
                </template>
              </el-menu-item>
              <el-menu-item v-if="userInfo.isAdmin || !userInfo.companyId" index="/company">
                <template #title>
                  <div>开票信息</div>
                </template>
              </el-menu-item>
              <el-menu-item v-if="userInfo.isAdmin" index="/member">
                <template #title>
                  <div>成员管理</div>
                </template>
              </el-menu-item>
            </el-sub-menu>
            <el-menu-item v-if="userInfo.isAdmin || !userInfo.companyId" index="/record">
              <template #title>
                <div>订单记录</div>
              </template>
            </el-menu-item>
             <el-menu-item index="/notice">
              <template #title>
                <div>通知公告</div>
              </template>
            </el-menu-item>
             <el-menu-item index="/recycle" v-if="userInfo && userInfo.companyId * 1 === 43">
              <template #title>
                <div>回收站</div>
              </template>
            </el-menu-item>
            <!-- <el-menu-item index="/address">
              <template #title>
                <div>联系地址管理</div>
              </template>
            </el-menu-item>
            <el-menu-item v-if="userInfo.isAdmin" index="/member">
              <template #title>
                <div>成员管理</div>
              </template>
            </el-menu-item>
            <el-menu-item v-if="userInfo.isAdmin || !userInfo.companyId" index="/record">
              <template #title>
                <div>订单记录</div>
              </template>
            </el-menu-item>
            <el-menu-item index="/aftersale">
              <template #title>
                <div>我的售后</div>
              </template>
            </el-menu-item>
            <el-menu-item v-if="userInfo.isAdmin || !userInfo.companyId" index="/company">
              <template #title>
                <div>开票信息</div>
              </template>
            </el-menu-item>
            <el-menu-item index="/notice">
              <template #title>
                <div>通知公告</div>
              </template>
            </el-menu-item> -->
          </el-menu>
          <div class="aside-footer">
            <div class="package-tips" v-if="isGetUser && userInfo && userInfo.id && userInfo.packageMap['CREATE_WRITE'] &&
              (userInfo.packageMap['CREATE_WRITE'].reduce((acc, cur) => acc + cur.balance, 0)/userInfo.packageMap['CREATE_WRITE'].reduce((acc, cur) => acc + cur.originalBalance, 0) < 0.1)">
              您的套餐可用余额仅剩下【{{ userInfo.packageMap['CREATE_WRITE'].reduce((acc, cur) => acc + cur.balance, 0) }}】件，
              为了不影响您正常的使用，请及时充值
            </div>
            版本V2.9.0
            <div style="color:#6196ff;cursor: pointer;margin-top: 2px;" @click="feedback">意见反馈</div>
          </div>
        </el-aside>
        <div class="main-box">
          <el-main id="main">
            <router-view v-slot="{ Component, route }">
              <keep-alive
                :exclude="[
                  'submitResult',
                  'createApplicant',
                  'confirm',
                  'correction',
                  'orderDetail',
                  'addApplicant',
                  'printingMaterials',
                  'development',
                  'new',
                  'submit',
                  'autoReview',
                  'protect',
                  'editor',
                  'auth',
                  'balance',
                  'package',
                  'packageRecord',
                  'packageList',
                  'apply',
                  'noticeDetail',
                  'newManual'
                ]"
              >
                <component :is="Component" :key="route.name"></component>
              </keep-alive>
            </router-view>
          </el-main>
        </div>
      </el-container>
    </el-container>
    <el-dialog v-model="upPassVisible" title="修改密码">
      <el-form :model="upPassForm" :rules="formRules" ref="upPassFormRef">
        <el-form-item
          label="旧密码"
          prop="oldPassword"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            show-password
            placeholder="请输入旧密码"
            v-model="upPassForm.oldPassword"
            :disabled="isEdit"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPassword"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            show-password
            placeholder="设置6位及以上字母+数字组合的密码"
            v-model="upPassForm.newPassword"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="btn-item btn-active"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="doChangePassword"
          >
            确定
          </el-button>
          <div class="btn-item" @click="upPassVisible = false">取消</div>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      style="width: 490px"
      v-model="upPhoneVisible"
      :title="userInfo.phone ? '修改绑定手机' : '设置手机号'">
      <el-form :model="upPhoneForm" :rules="formRules" ref="upPhoneFormRef">
        <el-form-item
          v-if="userInfo.phone"
          label="原手机号"
          :label-width="formLabelWidth"
        >
          <div>{{ userInfo.phone }}</div>
        </el-form-item>
        <el-form-item
          label="密码"
          v-if="userInfo.phone"
          prop="password"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            show-password
            placeholder="请输入登录密码"
            v-model="upPhoneForm.password"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item
          v-if="userInfo.phone"
          label="新手机号"
          class="phone-code"
          prop="telephone"
          :label-width="formLabelWidth"
        >
          <el-input
            oninput="value=value.replace(/\D/g, '')"
            v-model="upPhoneForm.telephone"
            placeholder="请输入新手机号码"
            :maxlength="11"
            autocomplete="off"
          />
          <el-button
            class="code-btn"
            @click="getCode"
            link
            :disabled="!showText"
            >{{ showText ? "获取验证码" : second + "s后重新获取" }}</el-button
          >
        </el-form-item>
        <el-form-item
          v-else
          label="手机号"
          class="phone-code"
          prop="telephone"
          :label-width="formLabelWidth"
        >
          <el-input
            oninput="value=value.replace(/\D/g, '')"
            v-model="upPhoneForm.telephone"
            placeholder="请输入手机号码"
            :maxlength="11"
            autocomplete="off"
          />
          <el-button
            class="code-btn"
            @click="getCode"
            link
            :disabled="!showText"
            >{{ showText ? "获取验证码" : second + "s后重新获取" }}</el-button
          >
        </el-form-item>
        <el-form-item
          label="验证码"
          prop="authCode"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="upPhoneForm.authCode"
            placeholder="请输入短信验证码"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            class="btn-item btn-active"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="doChangePhone"
          >
            确定
          </el-button>
          <div class="btn-item" @click="upPhoneVisible = false">取消</div>
        </span>
      </template>
    </el-dialog>
    <PayLoadding v-model="showPayloadding"></PayLoadding>
    <el-dialog
      style="width: 800px"
      v-model="showExportList"
      title="批量下载列表">
      <div class="table-row">
        <el-table class="table"
          :header-cell-style="{ background: '#FAFAFA', color: '#555555', fontSize: '12px'}"
          :data="tableData" empty-text="暂无数据">
          <el-table-column prop="createTime" label="时间" width="160">
            <template #default="scope">
              <div>{{ formatDate(scope.row.createTime, 'YYYY-MM-DD HH:mm:ss') }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="内容"></el-table-column>
          <el-table-column prop="status" label="状态">
            <template #default="scope">
              <el-tag v-if="scope.row.status === 0" type="primary" effect="dark" round>打包中</el-tag>
              <el-tag v-else-if="scope.row.status === 1" type="success" effect="dark" round>成功</el-tag>
              <el-tag v-else-if="scope.row.status === 2" type="danger" effect="dark" round>失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作" width="80" align="center">
            <template #default="scope">
              <div v-if="scope.row.status === 1" class="flex-center">
                <div @click="handleClick(scope.row)" class="btn-link">下载</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 16px;" class="pagination flex-end">
          <el-pagination background small
            @current-change="handleCurrentChange"
            layout="slot, prev, pager, next, jumper"
            :page-size="batchDownloadForm.pageSize"
            :current-page="batchDownloadForm.pageNum"
            :total="batchDownloadTotal">
            <span>共{{batchDownloadTotal}}条</span>
            </el-pagination>
        </div>
        <div style="margin-top: 20px;background: #fceaec;height: 60px;line-height: 60px;width: 100%;">批量下载的文件包仅保留24小时，请及时下载</div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <!-- <el-button
            class="btn-item btn-active"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="doChangePhone"
          >
            确定
          </el-button> -->
          <div class="btn-item" @click="showExportList = false">关闭</div>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="less">
.layout {
  .phone-code {
    .code-btn {
      position: absolute;
      right: 16px;
      color: #6196ff;
    }
  }
  :deep(.el-dialog) {
    width: 400px;
  }
  :deep(.el-dialog__header) {
    text-align: left;
  }
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .add_submit {
      width: 100px;
      height: 31px;
      line-height: 31px;
      background: #6196ff;
      border-radius: 50px;
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }
    .add_cancel {
      width: 100px;
      height: 29px;
      line-height: 29px;
      border-radius: 50px 50px 50px 50px;
      opacity: 1;
      border: 1px solid #6196ff;
      font-size: 16px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      color: #6196ff;
      margin-left: 16px;
      text-align: center;
      cursor: pointer;
    }
  }
  .el-header {
    padding: 0;
    height: 50px !important;
    position: fixed;
    width: 100%;
    z-index: 10000;
  }
  .el-aside {
    top: 50px;
    background: #f7f7f7;
    position: fixed;
    height: calc(100vh - 50px);
    z-index: 99;
    .aside-footer {
      position: absolute;
      width: 100%;
      bottom: 20px;
      color: #333;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .package-tips {
        margin: 16px;
        border: 1px solid red;
        color: red;
        padding: 16px;
        border-radius: 5px;
        line-height: 20px;
        text-align: left;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .el-menu {
    padding-top: 48px;
    border-right: none;
  }
  :deep(.el-sub-menu) {
    font-size: 12px;
    color: #333333;
    .el-sub-menu__title {
      font-size: 12px !important;
      color: #333333 !important;
      display: flex;
      justify-content: flex-start;
      padding: 0 16px 0 40px !important;
    }
    .el-menu-item {
      background-color: #FFF !important;
    }
    .el-menu-item.is-active {
      background-color: #FFF !important;
      color: #1a1a1a !important;
      font-weight: bold;
    }

    .el-menu-item:hover {
      background-color: #FFF !important;
      color: #1a1a1a !important;
      font-weight: bold;
    }
  }
  :deep(.el-sub-menu.is-active) {
    .el-sub-menu__title {
      background-color: #e6e6e6 !important;
      color: #1a1a1a !important;
      font-weight: bold;
    }
  }
  .el-menu-item {
    width: 208px !important;
    height: 40px !important;
    line-height: 40px !important;
    text-align: center;
    display: inline-block;
    font-size: 12px;
    color: #333333;
    display: flex;
    justify-content: flex-start;
    padding: 0 16px 0 40px !important;
  }

  .el-menu-item.is-active {
    background-color: #e6e6e6 !important;
    color: #1a1a1a !important;
    font-weight: bold;
  }

  .el-menu-item:hover {
    background-color: #e6e6e6 !important;
    color: #1a1a1a !important;
    font-weight: bold;
  }
  .header {
    .header-nav {
      padding: 0px 40px;
      height: 50px;
      background: #ffffff;
      color: #666666;
      box-shadow: 0px 8px 24px 0px rgba(149, 157, 165, 0.2);
      font-size: 12px;
      font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
        "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-weight: 400;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      :deep(:focus-visible) {
        outline: none !important;
      }
      :deep(.el-dropdown) {
        color: inherit;
      }
      .info {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .el-dropdown-link {
          cursor: pointer;
        }
        .account {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          margin: 0 8px 0 8px;
        }
        .info-create {
          width: 133px;
          height: 39px;
          border-radius: 100px;
          opacity: 1;
          border: 1px solid #6196ff;
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #6196ff;
          box-sizing: border-box;
          cursor: pointer;
          margin-right: 58px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .info-list {
          padding: 0 16px;
          height: 39px;
          border-radius: 100px;
          opacity: 1;
          border: 1px solid #6196ff;
          font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          color: #6196ff;
          box-sizing: border-box;
          cursor: pointer;
          margin-right: 58px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          svg {
            width: 20px;
            height: 20px;
          }
        }
        .info-icon {
          height: 20px;
          width: 20px;
          border-radius: 50%;
          background: #6196ff;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
          }
        }
      }
      .home-title {
        // cursor: pointer;
        color: #333333;
        font-weight: bold;
        width: 168px;
        text-align: left;
      }
      .title {
        flex: 1;
        font-weight: bold;
        .balance {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          margin: 0 8px 0 24px;
        }
        .up {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #6196ff;
          cursor: pointer;
          img {
            margin: 0 6px 0 10px;
          }
        }
        .balance-value {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #6196ff;
        }
        .balance-all {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          background: #F9F9F9;
          padding: 2px 24px;
          .balance-item + .balance-item {
            margin-left: 16px;
          }
          .balance-item-empty {
            margin-left: 0 !important;
          }
          .balance-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .balance-num {
              font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
              color: #6196ff;
              font-size: 14px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .balance-text {
              font-size: 12px;
              color: #999;
              font-weight: 400;
            }
          }
        }
        .balance-value1 {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          color: #6196ff;
          margin-right: 8px;
        }
        .balance-value2 {
          // font-size: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          margin-right: 8px;
        }
        .balance1 {
          margin-left: 16px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          cursor: pointer;
        }
        .balance2 {
          margin-left: 8px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          cursor: pointer;
        }
        .charge {
          margin-left: 16px;
          width: 64px;
          height: 19px;
          line-height: 19px;
          background: #ff8f1f;
          border-radius: 100px;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          color: #ffffff;
          margin-right: 17px;
          cursor: pointer;
        }
        .fee-info {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          cursor: pointer;
          span {
            margin-left: 4px;
          }
        }
      }
      .logout {
        cursor: pointer;
      }
    }
  }
  .main-box {
    position: absolute;
    height: calc(100vh - 50px);
    width: calc(100vw - 208px);
    top: 50px;
    left: 208px;
    // overflow: hidden;
  }
  .el-main {
    // overflow: auto;
    // margin-left: 208px;
    // margin-top: 50px;
    padding: 0;
    margin: 0 24px;
    overflow: unset;
    height: calc(100vh - 50px);
    background: #ffffff;
  }
}
.package-body {
  max-height: 800px;
  overflow-y: auto;
  padding-right: 12px;
}
.package-pop {
  padding-bottom: 8px;
  .package-title {
    height: 23px;
    font-size: 12px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 500;
    color: #1a1a1a;
    line-height: 23px;
  }
  .package-item {
    height: 19px;
    font-size: 12px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    color: #767676;
    line-height: 19px;
    .item-value {
      color: #6196ff;
      margin-left: 16px;
    }
    .package-detail {
      color: #6196ff;
      cursor: pointer;
    }
  }
}
.package-pop + .package-pop {
  border-top: 1px solid #d8d8d8;
  padding-top: 8px;
}
</style>
